import { render, staticRenderFns } from "./CarRight.vue?vue&type=template&id=c403c246&scoped=true&"
import script from "./CarRight.vue?vue&type=script&lang=js&"
export * from "./CarRight.vue?vue&type=script&lang=js&"
import style0 from "./CarRight.vue?vue&type=style&index=0&id=c403c246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c403c246",
  null
  
)

export default component.exports